'use strict';
import * as $j_app$002edata$002e$002dUser$002dDetails$0024package$0024$002dUser$002dLast$002dName$0024 from "./app.data.-User-Details$package$-User-Last-Name$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_UserDetails$package$UserLastNameForm$() {
  this.aGo = null;
  this.aGz = null;
  this.aGr = null;
  this.aGs = false;
  this.aGx = null;
  this.aGy = false;
  this.aGp = null;
  this.aGq = false;
  this.aGv = null;
  this.aGw = false;
  this.aGt = null;
  this.aGu = false;
  $n_Lapp_data_UserDetails$package$UserLastNameForm$ = this;
  this.aGo = $j_app$002edata$002e$002dUser$002dDetails$0024package$0024$002dUser$002dLast$002dName$0024.$m_Lapp_data_UserDetails$package$UserLastName$();
  this.aGz = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($j_app$002edata$002e$002dUser$002dDetails$0024package$0024$002dUser$002dLast$002dName$0024.$m_Lapp_data_UserDetails$package$UserLastName$());
}
export { $c_Lapp_data_UserDetails$package$UserLastNameForm$ as $c_Lapp_data_UserDetails$package$UserLastNameForm$ };
$p = $c_Lapp_data_UserDetails$package$UserLastNameForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_UserDetails$package$UserLastNameForm$;
/** @constructor */
function $h_Lapp_data_UserDetails$package$UserLastNameForm$() {
}
export { $h_Lapp_data_UserDetails$package$UserLastNameForm$ as $h_Lapp_data_UserDetails$package$UserLastNameForm$ };
$h_Lapp_data_UserDetails$package$UserLastNameForm$.prototype = $p;
$p.eR = (function() {
  return this.aGo;
});
$p.eO = (function() {
  return this.aGz;
});
$p.b9 = (function() {
  if ((!this.aGs)) {
    this.aGr = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aGs = true;
  }
  return this.aGr;
});
$p.b3 = (function() {
  if ((!this.aGy)) {
    this.aGx = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aGy = true;
  }
  return this.aGx;
});
$p.aG = (function() {
  if ((!this.aGq)) {
    this.aGp = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aGq = true;
  }
  return this.aGp;
});
$p.az = (function() {
  if ((!this.aGw)) {
    this.aGv = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aGw = true;
  }
  return this.aGv;
});
$p.aY = (function() {
  if ((!this.aGu)) {
    this.aGt = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aGu = true;
  }
  return this.aGt;
});
var $d_Lapp_data_UserDetails$package$UserLastNameForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_UserDetails$package$UserLastNameForm$, "app.data.UserDetails$package$UserLastNameForm$", ({
  Ff: 1,
  N: 1
}));
export { $d_Lapp_data_UserDetails$package$UserLastNameForm$ as $d_Lapp_data_UserDetails$package$UserLastNameForm$ };
var $n_Lapp_data_UserDetails$package$UserLastNameForm$;
function $m_Lapp_data_UserDetails$package$UserLastNameForm$() {
  if ((!$n_Lapp_data_UserDetails$package$UserLastNameForm$)) {
    $n_Lapp_data_UserDetails$package$UserLastNameForm$ = new $c_Lapp_data_UserDetails$package$UserLastNameForm$();
  }
  return $n_Lapp_data_UserDetails$package$UserLastNameForm$;
}
export { $m_Lapp_data_UserDetails$package$UserLastNameForm$ as $m_Lapp_data_UserDetails$package$UserLastNameForm$ };
//# sourceMappingURL=app.data.-User-Details$package$-User-Last-Name-Form$.js.map
